import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

let initialOptions = [
  { value: 'per_unit', label: 'Per Unit' },
  { value: 'tiered', label: 'Tiered' },
];

const BillingSchemeInput = ({ formData, onChange, disabled = false }) => {
  const [options, setOptions] = useState(initialOptions);

  const handleChange = (e) => {
    let updateData = {
      ...formData,
      billing_schema: e.target.value,
      tiers_mode: 'graduated',
      tiers: [{ starting_from: 1, up_to: 'inf', unit_amount: 0, flat_amount: 0 }],
    };

    if (e.target.value === 'tiered') {
      delete updateData.price;
    }
    onChange(updateData);
  };

  return (
    <FormControl fullWidth required>
      <InputLabel shrink>Billing Schema</InputLabel>
      <Select
        label="Billing Schema"
        value={formData.billing_schema}
        onChange={handleChange}
        size="small"
        disabled={disabled}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BillingSchemeInput;
